export default "__VITE_ASSET__BYsGUCnq__"